import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import type { OmitStylesHTMLAttributes } from '../../types';

const alertVariants = cva(
    'rocco-alert relative w-full rounded-lg border p-4 [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:text-foreground [&>svg~*]:pl-7',
    {
        variants: {
            variant: {
                default: 'bg-background text-foreground',
                destructive:
                    'border-destructive/50 text-destructive dark:border-destructive [&>svg]:text-destructive',
            },
        },
        defaultVariants: {
            variant: 'default',
        },
    },
);

export const Alert = React.forwardRef<
    HTMLDivElement,
    OmitStylesHTMLAttributes<HTMLDivElement> &
        VariantProps<typeof alertVariants>
>(({ variant, ...props }, ref) => (
    <div
        ref={ref}
        role="alert"
        className={alertVariants({ variant })}
        {...props}
    />
));

Alert.displayName = 'Alert';
